import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapMutations } from "vuex";
import request from "@/utils/request";
import { expertInstitution } from "@/api";
export default {
  components: {},
  data: function data() {
    return {
      scanImg: {},
      form: {
        age: null,
        baby: null,
        ill: []
      },
      ills: ["中重度肝肾损伤", "胰腺炎病史", "甲状腺髓样癌病史或家族史", "2型多发性内分泌肿瘤综合征（MEN2）"],
      checkInvert: false,
      showForm: true,
      show1: false
    };
  },
  beforeRouteLeave: function beforeRouteLeave() {
    this.UPDATE_SHOWNAVLOGO_VALUE(false);
  },
  created: function created() {
    this.UPDATE_SHOWNAVLOGO_VALUE(true);
    this.queryExpertInstitution();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(["UPDATE_SHOWNAVLOGO_VALUE"])), {}, {
    // 反选
    handleInvertCheckChange: function handleInvertCheckChange(val) {
      console.log(val);
      if (val) {
        this.form.ill = [];
        this.checkInvert = true;
      } else {
        this.checkInvert = false;
      }
    },
    // 多选
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      this.checkInvert = false;
      console.log(this.form.ill);
    },
    submit: function submit() {
      var _this$form = this.form,
        age = _this$form.age,
        baby = _this$form.baby,
        ill = _this$form.ill;
      if (age === null) {
        this.$toast("请回答第1题！");
      } else if (baby === null) {
        this.$toast("请回答第2题！");
      } else if (ill.length === 0 && !this.checkInvert) {
        this.$toast("请回答第3题！");
      } else {
        this.showForm = false;
        if (age == 1 && baby == 0 && this.checkInvert) {
          this.show1 = true;
        } else {
          this.show1 = false;
        }
      }
    },
    queryExpertInstitution: function queryExpertInstitution() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, scanImg;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return request.get(expertInstitution);
            case 2:
              res = _context.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              scanImg = {
                miniProgramImg: res.obj.miniProgramImg,
                customerServiceImg: res.obj.customerServiceImg
              };
              _this.scanImg = scanImg;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  })
};